import { $ } from "../lib/dom.js";
import { escHtml } from "../lib/hints.js";
import { api } from "../api.js";
import { renderSystemAdminsSection } from "./system-admins.js";

function errText(data) {
  const err = data && data.error;
  if (err && err.message) return err.message;
  if (data && typeof data.message === "string" && data.message) return data.message;
  if (data && typeof data.detail === "string" && data.detail) return data.detail;
  return "申请失败";
}

function fieldValue(box, sel) {
  const el = box.querySelector(sel);
  return el && "value" in el ? String(el.value || "").trim() : "";
}

const STATUS_CLASS = {
  approved: "ok",
  pending: "",
  closed: "err",
  rejected: "err",
  none: "",
};

function cardHtml(card, canApply) {
  const code = card.code;
  const label = escHtml(card.status_label || "未开通");
  const detail = escHtml(card.detail || "");
  let actions = "";
  if (code === "brand") {
    actions = `<button type="button" class="secondary js-cap-brand">去登记品牌</button>`;
  } else if (code === "dist") {
    actions = `<button type="button" class="secondary js-cap-dist">去概览开通分销</button>`;
  } else if (code === "designer" && canApply && card.status !== "approved" && card.status !== "pending") {
    actions = `<div class="mcp-grid-2">
      <label>设计主体名称<input class="js-cap-studio" type="text" value="${escHtml(card.studio_name || "")}" /></label>
      <label>联系人 *<input class="js-cap-contact" type="text" value="${escHtml(card.contact || "")}" placeholder="必填" /></label>
    </div>
    <label>说明<input class="js-cap-note" type="text" value="${escHtml(card.note || "")}" placeholder="一句即可，可不填" /></label>
    <button type="button" class="js-cap-designer">申请开通</button>`;
  } else if (code === "retail_store" && canApply && card.status !== "approved" && card.status !== "pending") {
    actions = `<div class="mcp-grid-2">
      <label>门店名<input class="js-cap-shop" type="text" value="${escHtml(card.shop_name || "")}" /></label>
      <label>城市<input class="js-cap-city" type="text" value="${escHtml(card.city || "")}" /></label>
    </div>
    <button type="button" class="js-cap-retail">申请开通</button>`;
  }
  return `<section class="card" style="margin-top:12px">
    <div class="brand-panel-head">
      <h3>${escHtml(card.title || code)}</h3>
      <span class="${STATUS_CLASS[card.status] || ""}">${label}</span>
    </div>
    <p class="mc-desc">${detail}</p>
    ${actions}
  </section>`;
}

async function load(box) {
  box.innerHTML = "加载中…";
  const { ok, data } = await api("GET", "/api/v1/merchant/capabilities");
  if (!ok || !data) {
    box.innerHTML = "加载失败";
    return;
  }
  const cards = data.cards || [];
  const canApply = !!data.can_apply;
  box.innerHTML = cards.map((c) => cardHtml(c, canApply)).join("");
  const brandBtn = box.querySelector(".js-cap-brand");
  if (brandBtn) {
    brandBtn.addEventListener("click", () => {
      location.hash = "brand";
    });
  }
  const distBtn = box.querySelector(".js-cap-dist");
  if (distBtn) {
    distBtn.addEventListener("click", () => {
      location.hash = "overview";
      const btn = $("btn-dist-open");
      if (btn) btn.click();
    });
  }
  const designerBtn = box.querySelector(".js-cap-designer");
  if (designerBtn) {
      designerBtn.addEventListener("click", async () => {
        const studio = fieldValue(box, ".js-cap-studio");
        const contact = fieldValue(box, ".js-cap-contact");
        const note = fieldValue(box, ".js-cap-note");
        if (!studio) {
          alert("请填写设计主体名称");
          return;
        }
        if (!contact) {
          alert("请填写联系人");
          return;
        }
        designerBtn.disabled = true;
        const res = await api("POST", "/api/v1/merchant/capabilities/designer", {
          body: { studio_name: studio, contact, note },
        });
        designerBtn.disabled = false;
        if (!res.ok) {
          alert(errText(res.data));
          return;
        }
        await load(box);
      });
  }
  const retailBtn = box.querySelector(".js-cap-retail");
  if (retailBtn) {
    retailBtn.addEventListener("click", async () => {
      retailBtn.disabled = true;
      const res = await api("POST", "/api/v1/merchant/capabilities/retail-store", {
        body: {
          shop_name: (box.querySelector(".js-cap-shop") || {}).value || "",
          city: (box.querySelector(".js-cap-city") || {}).value || "",
        },
      });
      retailBtn.disabled = false;
        if (!res.ok) {
          alert(errText(res.data));
          return;
        }
      await load(box);
    });
  }
}

export function renderCapabilityOpenPanel() {
  const box = $("capability-cards");
  const adminsBox = $("capability-system-admins");
  if (!box) return;
  void load(box);
  renderSystemAdminsSection(adminsBox, {
    onChanged: () => renderCapabilityOpenPanel(),
  });
}
